export const SITE = {
  name: "Shree Aradhana Jewellers",
  short: "Aradhana Jewellers",
  domain: "aradhanajewellers.com",
  phoneDisplay: "+91 94226 82086",
  phoneRaw: "+919422682086",
  whatsapp: "919422682086",
  email: "care@aradhanajewellers.com",
  address: "Shop No. 48, Ostwal Empire, Arihant Market, Boisar, Maharashtra 401501",
  mapLink:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("Ostwal Empire, Arihant Market, Boisar, Maharashtra 401501"),
  gst: "27ACVPR2719A1Z9",
  hours: "10:30 AM – 8:30 PM · Open all 7 days",
};

export const waLink = (msg) => `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_RATES = { gold_24k: 7410, gold_22k: 6795, gold_18k: 5560, silver: 92.5 };

// Flip to false once the shop is ready to show live board rates publicly.
export const RATES_COMING_SOON = true;
export const RATES_SOON_LABEL = "Coming soon";

export const inr = (n, decimals = 0) =>
  "₹" +
  new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(Number(n) || 0);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -100 });
  else el.scrollIntoView({ behavior: "smooth" });
};
